<template>
  <div id="page-wrapper">
    <div id="page">
      <app-header></app-header>
      <div class="page-body">
        <app-navbar></app-navbar>
        <div class="main-page-content  ml-0">
          <template v-if="!steps.length">
            <div class="no-submissions spinner h-100 text-center d-flex justify-content-center align-items-center"
            >
              <div>
                <i class="fa-3x fas fa-circle-notch fa-spin"></i>
                <p class="mt-3 mb-2">{{ $t('message.please_wait') }}</p>
                <p class="small">{{ $t('message.vitamins_are_being_loaded') }}</p>
              </div>

            </div>
          </template>
          <template v-else>
            <div id="main-wrapper" class="layout-main-wrapper clearfix">
              <div id="main" class="container ml-0">
                <!--            <div id="main" class="container-fluid">-->
                <div class="row row-offcanvas row-offcanvas-left clearfix">
                  <main class="main-content col content-full-width" id="content" role="main">
                    <section class="section vitamins">
<!--                    <div class="d-none debug">-->
<!--                      <button class=" btn d-none btn-danger" @click.prevent="postTestSubmission">-->
<!--                        Post random test submission-->
<!--                      </button>-->
<!--                      <button class=" btn d-none btn-danger" @click.prevent="postTestSubmission7">-->
<!--                        Post all 7 test submission-->
<!--                      </button>-->
<!--                      <button class=" btn d-none btn-danger" @click.prevent="postTestSubmissionMax">-->
<!--                        Post all 7, unhealth 1 test submission-->
<!--                      </button>-->
<!--                      <button class=" btn d-none btn-danger" @click.prevent="randomAnswers">-->
<!--                        Fill all questions randomly without submitting-->
<!--                      </button>-->
<!--                    </div>-->
                      <div class="mb-4 webform-progress clearfix">
                        <ul class="webform-progress-tracker progress-tracker progress-tracker--center">
                          <li v-for="(step,i) in steps"
                              class="progress-step"
                              :class="{'is-active':activeStep == (i),'is-complete':activeStep > i,'step invalid' : step.invalid}"
                              :data-title="steps[i].title">
                            <div class="progress-marker" @click="setStep(i)">
                              <!--                              {{i+1}}-->
                              <small>{{ step.title }}</small>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div class="float-right toggler d-flex ml-auto" v-if="previousAvailable">

                        <button @click.prevent="showPrevious = !showPrevious" class="btn font-weight-light d-flex">
                          {{ $t('message.show_previous_score') }}
                          &nbsp;
                          <!--                          <template v-if="showPrevious">-->
                          <template v-if="showPrevious">
                            <span class="previous-active previous-botton d-block">
                              <i class="fa-sm fas fa-undo"></i>
                            </span>
                          </template>
                          <template v-else>
                            <span class="previous-botton back d-block">
                              <i class="fa-sm fal fa-undo"></i>
                            </span>
                          </template>
                        </button>
                        <!--                        <label class=" ml-2 switch">-->
                        <!--                        <input v-model="showPrevious" type="checkbox">-->
                        <!--                        <span class="slider round">-->
                        <!--                        <div class="w-50 h-100 float-left d-flex align-items-center justify-content-center small">-->
                        <!--&lt;!&ndash;                          <div>Off</div>&ndash;&gt;-->
                        <!--                        </div>-->
                        <!--                        <div class="w-50 h-100 float-right d-flex align-items-center justify-content-center small">-->
                        <!--&lt;!&ndash;                          <div>On</div>&ndash;&gt;-->
                        <!--                        </div>-->
                        <!--                      </span>-->
                        <!--                      </label>-->
                      </div>


                      <!--                    <label @click="togglePrevious" class="toggle" for=""><input type="checkbox"></label>-->
                      <!--                    <button @click="togglePrevious">toggle previous</button>-->
                      <form class="" :class="showPrevious ? 'show-previous' : ''" action="/" method="post"
                            id="vitamins-form"
                            accept-charset="UTF-8">
                        <template v-for="(step,ind) in steps">
                          <step :ref="'step-'+ind" :index="ind" v-show="activeStep == ind" :step="step"></step>
                        </template>

                        <div class="form-actions js-form-wrapper form-group" id="edit-actions">
                          <button
                            class="btn-prev-step btn btn-primary mr-0"
                            type="button" name="prev" value="< Previous Page"
                            v-if="activeStep > 0"
                            @click.prevent="setStep(activeStep-1)"
                          >&lt; {{ $t('message.previous_page') }}
                          </button>
                          <button
                            class="ml-3 btn-next-step btn btn-primary"
                            type="button"
                            name="next" value="Next Page >"
                            v-if="activeStep < this.steps.length-1"
                            @click.prevent="setStep(activeStep+1)"
                          >{{ $t('message.next_page') }} &gt;
                          </button>
                          <!--                        <button-->
                          <!--                          class="button form-submit btn btn-primary"-->
                          <!--                          type="button"-->
                          <!--                          name="submit" value="Next Page >"-->
                          <!--                          v-if="activeStep == this.steps.length-1"-->
                          <!--                          @click.prevent="submitForm('draft')"-->
                          <!--                        >{{ $t('message.save_draft') }}-->
                          <!--                        </button>-->

                        </div>
                        <div
                          class="form-actions js-form-wrapper form-group"
                          id="edit-actions-2" style="margin-top: 20px;">
                          <button
                            class="btn_save_draft button form-submit btn btn-primary"
                            type="button"
                            name="submit" :value="$t('message.save_draft')"
                            @click.prevent="submitForm($event,'draft')"
                          >{{ $t('message.save_draft') }}
                          </button>
                          <button
                            class="btn_finalize ml-3 button mt-0 form-submit btn btn-primary"
                            type="submit"
                            name="submit" :value="$t('message.finalize')"
                            v-if="activeStep == this.steps.length-1"
                            @click.prevent="submitForm($event,'final')"
                          >
                            {{ $t('message.finalize') }}
                          </button>

                        </div>
                        <!--                        todo: turn this back on for submission (un)publishing-->
                        <div v-if="activeStep == this.steps.length-1"
                             class="mb-3 justify-content-end ml-auto text-right d-flex align-items-center">
                          <div class="d-flex align-items-center">
                            <small>{{ $t('message.hide_submission') }}:</small>
                            <button @click.prevent="togglePublished()"
                                    type="button"
                                    class="btn btn-link cursor-pointer w-auto ml-2 justify-content-end d-flex align-items-center  switch">
                              <!--                                                      <input v-model="unpublished" type="checkbox">-->
                              <span class="pub" v-show="!unpublished">
                                <i class="fa-1x  fal fa-fw fa-eye"></i>
                              </span>
                              <span class="unpub" v-show="unpublished">
                                <i class="fa-1x score-c-1 fal fa-fw fa-eye-slash"></i>
                                <!--                                <i class="fa-1x score-c-1 fal fa-fw fa-eye-slash"></i>-->
                              </span>
                            </button>
                          </div>
                        </div>
                      </form>

                    </section>
                  </main>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Progress from "./Progress";
import Step from "./Step";
import Header from "../Header";
import Nav from "../Nav";
import store from "../../store/store";
import moment from 'moment'
import 'element-closest-polyfill';

export default {
  components: {
    appHeader: Header,
    appNavbar: Nav,
    progressInd: Progress,
    Step
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  created() {
    this.unsubscribe = store.subscribe((mutation, state) => {
      if (mutation.type === 'setLang') {
        this.initQuestions();
      }
    });
  },
  mounted() {
    if (this.draft) {
      this.getDraft().then(r => {
        this.initPreviousData().then(r => {
          this.initQuestions()
        });
      });
    } else {
      this.initPreviousData().then(r => {
        this.initQuestions()
      });
    }
  },
  data() {
    return { //todo use getters to get draft and previous from store
      submission_id: null,
      comments: [],
      invalid: false,
      unpublished: true,
      previousSubmission: null,
      previousAvailable: false,
      steps: [], //steps = vitamins, which contain subcategories, which contain questions
      activeStep: 0, //index of active step/vitamin, form steps watch this property and prev/next/progress buttons change it
      draft: this.$route.query.draft, // query parameter ?draft=true loads draft and fills answers
      // formData: store.state.vitaminFormData.draft, // form data; if editing draft, gets preloaded with draft data
      // finalData: store.state.vitaminFormData.previous, // data from last final submission, does not change
      showPrevious: false, // toggle to highlight last final submission answers
      defaultAnswers: {
        1: {
          comment: "",
          question: 1,
          score: 5
        },

      }
    }
  },
  computed: {
    draftAnswers() {
      return store.getters.getDraft
    },
    lastAnswers() {
      return store.getters.getPrevious
    },
    scoreTotal() {
      const scores = [];
      for (let key in this.formData.answers) {
        scores.push(this.formData.answers[key].score)
      }
      // console.log('scores', scores);
      return scores;
    },
    formData() {
      // console.log('formdata change')
      return store.state.vitaminFormData.draft
    }, // form data; if editing draft, gets preloaded with draft data
    finalData() {
      return store.state.vitaminFormData.previous
    }, // data from last final submission, does not change

  },
  watch: {
    formData() {
      //  console.log('formdata changed')
    }
  },
  methods: {
    randomAnswers() {
      for (let step_key in this.$refs) { //steps
        let step = this.$refs[step_key];
        for (let subcat_key in step[0].$refs) { //steps
          let subcat = step[0].$refs[subcat_key];
          for (let question_key in subcat[0].$refs) { //steps
            let question = subcat[0].$refs[question_key]
            question[0].setScore(false, Math.floor(Math.random() * 7) + 1)
          }
        }
      }
    },
    postTestSubmission() {
      for (let i = 1; i < 93; i++) {
        this.formData.answers[i] = {
          comment: '',
          question: i,
          score: Math.floor(Math.random() * 7) + 1
        }
      }
      this.postForm('final')
    },
    postTestSubmission7() {
      for (let i = 1; i < 93; i++) {
        this.formData.answers[i] = {
          comment: '',
          question: i,
          score: 7
        }
      }
      this.postForm('final')
    },
    postTestSubmissionMax() {
      let sc = null
      for (let i = 1; i < 93; i++) {
        if (i > 83) {
          sc = 1
        } else {
          sc = 7
        }
        this.formData.answers[i] = {
          comment: '',
          question: i,
          score: sc
        }
      }
      this.postForm('final')
    },
    async loadSubmissionData(type) {
      let subId = await this.getVitaminId(type); // load data with api call
      if (subId.data[0]) {
        let id = subId.data[0].id;
        const subData = await this.getVitaminData(id);
        if (subData.data) {
          store.commit('setVitaminData', [subData, type]);
        }
      }
    },
    async initQuestions() {
      store.commit('resetVitaminData');
      const questionResponse = await this.axios.get('/questions/order?lang=' + store.getters.getLang);
      const steps = questionResponse.data; // steps are component data, submission data is stored in state
      this.fillSteps(steps); // fill steps and questions with data from server
      if (this.draft) {
        await this.loadSubmissionData('draft');
      }
      await this.loadSubmissionData('previous');
    },
    async getVitaminData(id) {
      let request = '/submissions/' + id
      return await this.axios.get(request)
    },
    async getVitaminId(type) {
      let request = '/submissions?status=draft';
      if (type !== 'draft') {
        request = '/submissions?status_ne=draft&_sort=submitted:DESC&_limit=1';
      }
      return await this.axios.get(request);
    },
    calculateMax(score) {
      return Math.max(...score);
    },
    calculateMin(score) {
      return Math.min(...score);
    },
    calculateAvg(score) {
      const avg = arr => arr.reduce((a, b) => a + b, 0) / arr.length;
      return avg(score);
    },
    calculateMedian(score) {
      const arr = score;
      const mid = Math.floor(arr.length / 2),
        nums = [...arr].sort((a, b) => a - b);
      return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
    },
    calculateSubmissionResults() {
      const answers = this.formData.answers;
      let vipscores = [];
      let allscores = [];
      let vitaminScores = [];
      this.steps.forEach((vitamin, vitamin_index) => {
        let subcategoryScores = [];
        let subcategoryAverages = [];
        let vscores = [];
        for (let subcategory in vitamin.order) {
          let scores = [];
          vitamin.order[subcategory].question.forEach((question) => {
            for (let answer in answers) {
              if (answers[answer].question === question.id) {
                // let score = answers[answer].score;
                let enteredScore = answers[answer].score;
                let score = JSON.parse(JSON.stringify(enteredScore));
                if (vitamin.order[subcategory].scalereverse || vitamin.scalereverse) {
                  score = 8 - enteredScore;
                }
                scores.push(score);
                vscores.push(score);
                allscores.push(score);
                if (question.indexquestion) {
                  if (question.scalereverse) {
                    score = 8 - enteredScore;
                  }
                  vipscores.push(score)
                }
              }
            }
          });
          subcategoryScores.push({
            id: parseInt(vitamin.order[subcategory].id),
            title: vitamin.order[subcategory].title,
            average: this.calculateAvg(scores),
            lowest: this.calculateMin(scores),
            highest: this.calculateMax(scores),
            median: this.calculateMedian(scores),
          });
          subcategoryAverages.push(this.calculateAvg(scores))
        }
        vitaminScores.push({
          id: parseInt(vitamin.id),
          title: this.localizedField(vitamin, 'title'),
          average: this.calculateAvg(vscores),
          subcategoryaverage: this.calculateAvg(subcategoryAverages),
          lowest: this.calculateMin(vscores),
          highest: this.calculateMax(vscores),
          median: this.calculateMedian(vscores),
          children: subcategoryScores,
        })
      });

      return {
        average: this.calculateAvg(allscores),
        lowest: this.calculateMin(allscores),
        highest: this.calculateMax(allscores),
        median: this.calculateMedian(allscores),
        vipscore: this.calculateAvg(vipscores),
        children: vitaminScores,
      };

    },
    validateForm(data) {
      this.invalid = false;
      let valid = true;
      let answers = data.answers;
      let newsteps = JSON.parse(JSON.stringify(this.steps));
      newsteps.forEach((step) => {
        step.invalid = false;
        for (let key in step.order) {
          step.order[key].invalid = false;
          step.order[key].question.forEach((question) => {
            question.invalid = false;
            if (typeof (answers[question.id]) === 'undefined') {
              this.invalid = true;
              valid = false;
              step.order[key].invalid = true;
              step.invalid = true;
              question.invalid = true;
            } else if (answers[question.id].score === 0) {
              this.invalid = true;
              valid = false;
              step.order[key].invalid = true;
              step.invalid = true;
              question.invalid = true;
            }
          });
        }
      });
      this.steps = newsteps;
      return valid;
    },
    fillSteps(steps) {
      let stepArr = [];
      for (let key in steps) {
        steps[key].id = key;
        stepArr.push(steps[key]);
      }
      this.steps = stepArr;
    },
    postAllComments() {
      this.comments = [];
      this.steps.forEach((step, index) => {
        this.postCommentsForStep(step);
      });
      this.comments.forEach(comment => {
        this.postSingleComment(comment)
      })
    },
    postCommentsForStep(step) {
      for (let key in step.order) {
        this.postCommentsForSubcategory(step.order[key])
      }
    },
    postCommentsForSubcategory(subcategory) {
      if (subcategory.comment && typeof subcategory.comment !== 'undefined') {
        this.comments.push({
          text: subcategory.comment,
          userid: store.getters.getUserId,
          submissionid: this.submission_id,
          subcategoryid: subcategory.id,
        })
      }
    },
    postSingleComment(comment) {
      let filters = '';
      filters += `?subcategoryid=${comment.subcategoryid}`;
      filters += `&userid=${comment.userid}`;
      filters += `&submissionid=${comment.submissionid}`;
      this.axios.get(`/comments${filters}`).then(r => {
        if (r.data.length) {
          this.axios.put('/comments/' + r.data[0].id, comment)
        } else {
          this.axios.post('/comments', comment)
        }
      });
    },
    saveUserScore(score) {
      this.axios.put('/users/me', {
        average: score.average,
        median: score.median,
        lowest: score.lowest,
        highest: score.highest,
        vipscore: score.vipscore,
        data: score,
      });
    },
    togglePublished() {
      // console.log('toggling unpub from', this.unpublished)
      this.unpublished = !this.unpublished;
      // console.log('toggling unpub to', this.unpublished)
    },
    saveSubmissionAverages(score) {
      this.axios.post('/averages', {
        Average: score.average,
        Median: score.median,
        Lowest: score.lowest,
        Highest: score.highest,
        user: store.state.userId,
        date: new Date(),
        type: 'user',
        vipscore: score.vipscore,
        data: score,
      })
    },
    async saveSubmissionAnswers() {
      const postAnswers = [];
      for (let key in this.formData.answers) {
        this.formData.answers[key].submission = this.submission_id;
        postAnswers.push(this.formData.answers[key])
      }
      return await this.axios.post('/answers', postAnswers);
    },
    async saveSubmission(score, status) {
      const submission = {
        status: status,
        published: this.unpublished ? 0 : 1,// todo: turn this back on for submission (un)publishing
        // published: 1,
        submitted: new Date(),
        finalized: status === 'final' ? new Date() : null,
        user: store.state.userId,
        average: score.average,
        median: score.median,
        lowest: score.lowest,
        highest: score.highest,
        vipscore: score.vipscore,
        data: score,
      };
      const postedSubmission = await this.axios.post('/submissions', submission);
      this.submission_id = postedSubmission.data.id;
      return postedSubmission;
    },
    async postForm(status) {
      const el = document.querySelector('.btn_save_draft');
      const score = this.calculateSubmissionResults();
      // if (status === 'final') {
      if (status !== 'draft') {
        this.saveUserScore(score);
        this.saveSubmissionAverages(score);
      }
      await this.saveSubmission(score, status)
      this.postAllComments();
      await this.saveSubmissionAnswers();
      await this.logActivity('Posted new ' + status + ' submission', 'info (User)');
      this.loadingSuccess(el);
      if (status === 'final' || this.activeStep == this.steps.length - 1) {
        this.$router.push('/evolution');
      }
    },
    async initPreviousData() {
      const latestSub = await this.getLatestSubmission();
      if (latestSub.data.length) {
        const submission = latestSub.data[0];
        this.previousAvailable = true;
        const latestAnswers = await this.getSubmissionAnswers(submission.id);
        if (latestAnswers.data) {
          latestAnswers.data.forEach(answer => {
            store.commit('setLastAnswer', {id: answer.question.id, score: answer.score})
          });
          return latestAnswers;
        }
      } else {
        return latestSub
      }
    },
    submitForm(event, status) {
      const el = event.target;
      el.classList.add('loading');
      let validated = true;
      if (status === 'final') {
        validated = this.validateForm(this.formData);
      }
      if (validated) {
        this.postForm(status)
      } else {
        window.scrollTo(0, 0);
        this.loadingSuccess(el);
      }
    },
    setStep(step) {
      window.scrollTo(0, 0);
      this.activeStep = step;
    },
    async getDraft() {
      const draft = await this.getDraftVitamin();
      const draftAnswers = await this.axios.get('/answers?submission=' + draft.id);
      draftAnswers.data.forEach(answer => {
        store.commit('setDraftAnswer', {id: answer.question.id, score: answer.score})
      });
      if (this.draft) {
        let active = this.getActiveDraftStep();
        this.activeStep = active;
      }
      return draftAnswers
    },
    togglePrevious() {
      this.showPrevious = !this.showPrevious;
    },
    getActiveDraftStep() {
      let activeStepIndex = 0;
      let draftAnswers = store.getters.getDraft;
      let indexCounter = 0;
      let stop = false;

      this.steps.forEach((step, stepIndex) => {
        for (let subcategory in step.order) {
          let questions = step.order[subcategory].question;
          questions.forEach((question, questionIndex) => {
            if (!draftAnswers[question.id] && !stop) {
              activeStepIndex = indexCounter;
              stop = true;
            }
          })
        }
        indexCounter++;
      });

      return activeStepIndex;
    }
  }
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/Vitamins/Vitamins.vue